import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Group from '../courses/group';
import { LoadingIndicator, Tile } from '../../components';
import theme from '../../app.theme';
import SearchBar from '../search/search-bar/index';
import env from '../../../run-config';

class Tests extends Component {
  constructor(props) {
    super(props);

    this.testBaseUrl = this.props.match.url;
    this.state = {};
    this.onSearch = this.onSearch.bind(this);
    this.onClickShare = this.onClickShare.bind(this);
  }

  loadTest(test) {
    this.props.loadTest(test);
    this.props.history.push(`${this.testBaseUrl}/${test.id}`);
  }

  getStartedTests = (toplevelTests, groups) => {
    if (!this.props.testRuns) return [];
    var unfinishedTestRuns = this.props.testRuns.filter(t => !t.endDate);

    if (!unfinishedTestRuns || unfinishedTestRuns.length < 1) {
      return [];
    }

    var tests = [...toplevelTests];
    for (let i = 0; i < groups.length; i++) {
      if (groups[i].children && groups[i].children.length) {
        tests.push(...groups[i].children);
      }
    }

    var testRuns = this.props.testRuns;
    var testIdsForTestRuns = testRuns.map(t => t.testId);
    tests = tests.filter(f => testIdsForTestRuns.find(t => t === f.id))
    return tests;
  }

  filterDataByStartedTests = (data, startedTests) => {
    var groups = []

    for (let i = 0; i < data.length; i++) {
      let group = data[i].asMutable({ deep: true });
      const children = group.children.filter(f => !startedTests.find(t => t.id === f.id))
      if (children.length < 1) continue;
      group.children = children;
      groups.push(group);
    }

    return groups;
  }

  handleLoadTest = test => {
    const testRuns = this.props.testRuns;
    const openRunForTest = testRuns.find(t => t.testId === test.id);
    if (openRunForTest) {
      this.props.loadTest(test);
      this.props.setTestRun(openRunForTest)
    } else {
      this.props.startNewTestRun(test)
    }

    this.props.history.push(`${this.testBaseUrl}/${test.id}`);
  }

  renderTestGroups(data) {
    return (data.map(group => <Group
      key={group.id}
      group={group}
      // onClick={this.loadTest.bind(this)}
      onClick={this.handleLoadTest}
      onClickShare={this.onClickShare}
    />));
  }

  onSearch(searchTerm) {
    this.props.navigate(`search?searchTerm=${searchTerm}`);
  }

  onClickShare(test) {
    const url = `${env.apiHost}/tests/${test.id}/all`;
    this.props.onExportContent(url);
  }

  render() {
    if (this.props.isLoading) {
      return <LoadingIndicator show centered />;
    }

    if (!this.props.groups || !this.props.groups.length) {
      return <h3 className="text-center" style={{ marginTop: 40 }}>Keine Tests verfügbar</h3>;
    }

    let topLevelTests = this.props.groups.filter(c => c.type == 'test');
    let data = this.props.groups.asMutable().filter(t => t.type == 'group' && t.children && t.children.length);
    var startedTests = this.getStartedTests(topLevelTests, data);
    topLevelTests = topLevelTests.filter(f => !startedTests.find(t => t.id === f.id));
    data = this.filterDataByStartedTests(data, startedTests);

    if (startedTests.length) {
      data = [{ name: 'Begonnene Tests', children: startedTests }, ...data];
    }

    if (topLevelTests.length) {
      data.push({ name: 'Weitere Tests', children: topLevelTests });
    }

    return (
      <div className="col-lg-12 col-md-12 col-sm-12">
        <SearchBar location={this.props.location} onSearch={this.onSearch} />
        {this.renderTestGroups(data)}
      </div>
    );
  }
}

export default Tests;



// WEBPACK FOOTER //
// ./src/app/main/tests/tests.js